var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GChart',{ref:"chart",staticClass:"simomicsLineChart",staticStyle:{"min-height":"200px"},style:({'height' : _vm.height + 'px'}),attrs:{"type":"LineChart","data":_vm.chartData,"options":_vm.chartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }